export default __webpack_public_path__ + "images/models/b74ca04aed6fbf8ac2dcc071accb161e.glb";